import { action, computed, makeAutoObservable, runInAction } from "mobx";
import moment from "moment";
import { Api } from "../../common/Api";
import { RegionFilterStore } from "../RegionFilterStore";

export class UserActivitiesStore {
  filterStore: RegionFilterStore;

  loading = false;

  filter: any = {
    page: 0,
    size: 100,
    email: "",
    category: "",
    regionId: "",
    divisionId: "",
    communityId: "",
    period: [undefined, undefined],
  };

  sortedInfo = { columnKey: "createDate", order: "descend" };

  data = {
    total: 0,
    items: [],
  };

  get categories() {
    return [
      { id: "", name: "All" },
      { id: "Carpool Request", name: "Carpool Request" },
      { id: "Carpool Offer", name: "Carpool Offer" },
      { id: "Childcare Request", name: "Childcare Request" },
      { id: "uShare Request", name: "uShare Request" },
      { id: "uShare Offer", name: "uShare Offer" },
      { id: "eduShare Offer", name: "eduShare Offer" },
      { id: "Donate", name: "Donate" },
      { id: "Enrichment", name: "Enrichment" },
    ];
  }
  constructor() {
    makeAutoObservable(this, {
      pagination: computed,
    });
    this.filterStore = new RegionFilterStore(this);
    this.filterStore.periodLabel = "Activities Time";
  }

  get pagination() {
    return {
      current: this.filter.page + 1,
      pageSize: this.filter.size,
      total: this.data.total,
    };
  }

  @action onSearch(history) {
    this.onPage(history, 1, this.filter.size);
  }

  @action onPage(history, page, size) {
    let period: any[] = [undefined, undefined];
    if (this.filter.period?.[0]) {
      period = [
        moment(this.filter.period?.[0]).format("YYYY-MM-DD"),
        moment(this.filter.period?.[1]).format("YYYY-MM-DD"),
      ];
    }
    const query = new URLSearchParams({ ...this.filter, period, page: page - 1, size });
    history.push({ search: query.toString() });
  }

  @action onLocation(location) {
    const params = new URLSearchParams(location.search);
    const email = params.get("email") || "";
    const category = params.get("category") || "";
    const regionId = params.get("regionId") || "";
    const divisionId = params.get("divisionId") || "";
    const communityId = params.get("communityId") || "";
    const page = parseInt(params.get("page") || "0");
    const size = parseInt(params.get("size") || "100");

    const periodStr = params.get("period") || ",";
    const period = periodStr !== "," ? periodStr.split(",").map((x) => moment(x)) : [undefined, undefined];
    console.log("p", period);
    this.filter = { category, email, regionId, divisionId, communityId, period, page, size };

    this.refresh();
  }

  @action
  refresh() {
    this.loading = true;
    const { category, email, regionId, divisionId, communityId, period, page, size } = this.filter;

    const sorts = this.sortedInfo.order
      ? [{ field: this.sortedInfo.columnKey, order: this.sortedInfo.order === "descend" ? "desc" : "asc" }]
      : [];

    const filter: any = { category, email, regionId, divisionId, communityId, page, size, sorts };

    if (period?.[0]) {
      filter.period = [moment(period[0]).startOf("day").toISOString(), moment(period[1]).endOf("day").toISOString()];
    }
    return Api.userActivities
      .userActivities(filter)
      .then((res) => {
        runInAction(() => {
          this.data = res.data.userActivities;
        });
      })
      .finally(() =>
        runInAction(() => {
          this.loading = false;
        })
      );
  }
}

export const userActivitiesStore = new UserActivitiesStore();
